import { gql } from "@apollo/client";

/* =========================
   QUERIES
========================= */

export const GET_ALL_DONATIONS = gql`
  query GetAllDonations {
    getAllDonations {
      donation_id
      receipt_id
      donation_type_id
      donation_mode
      description
      value_amount
      devotee_name
      created_at
      item_name
      item_pic_url
      donor_pic_url
      paymentReference
      fileUrl
      chequeNumber
      bankName
      chequeImage
    }
  }
`;

export const GET_DONATION_BY_ID = gql`
  query GetDonationById($donation_id: ID!) {
    getDonationById(donation_id: $donation_id) {
      donation_id
      receipt_id
      donation_type_id
      donation_mode
      description
      value_amount
      created_at
      devotee_name
      item_name
      item_pic_url
      donor_pic_url
      paymentReference
      fileUrl
       chequeNumber
      bankName
      chequeImage
    }
  }
`;

export const GET_DONATIONS_BY_RECEIPT_ID = gql`
  query GetDonationsByReceiptId($receipt_id: ID!) {
    getDonationsByReceiptId(receipt_id: $receipt_id) {
      donation_id
      receipt_id
      donation_type_id
      donation_mode
      description
      value_amount
      created_at
      devotee_name
      item_name
      item_pic_url
      donor_pic_url
      paymentReference
      fileUrl
       chequeNumber
      bankName
      chequeImage
    }
  }
`;

/* =========================
   MUTATIONS
========================= */

export const CREATE_DONATION = gql`
  mutation CreateDonation($input: createDonationInput) {
    createDonation(input: $input) {
      donation_id
      receipt_id
      donation_type_id
      donation_mode
      description
      value_amount
      created_at
      devotee_name
      item_name
      item_pic_url
      donor_pic_url
      paymentReference
      fileUrl
       chequeNumber
      bankName
      chequeImage
    }
  }
`;

export const UPDATE_DONATION = gql`
  mutation UpdateDonation($input: updateDonationInput) {
    updateDonation(input: $input) {
      donation_id
      receipt_id
      donation_type_id
      donation_mode
      description
      value_amount
      created_at
      devotee_name
      item_name
      item_pic_url
      donor_pic_url
      paymentReference
      fileUrl
       chequeNumber
      bankName
      chequeImage
    }
  }
`;

export const DELETE_DONATION = gql`
  mutation DeleteDonation($donation_id: ID!) {
    deleteDonation(donation_id: $donation_id)
  }
`;
